<template>
    <div class="portlet">
    <form class="content" id="myform" method="post" novalidate="novalidate">
    <div class="form-body">
      <div class="form-group">
        <label class="control-label"><span>账</span><span style="display:inline-block;margin-left:25px;margin-right:10px">号</span></label>
        <input v-model="phone" class="input-large" type="text" autocomplete="off" placeholder="账号/邮箱/手机" name="data[username]">
      </div>
      <div class="form-group">
        <label class="control-label"><span>密</span><span style="display:inline-block;margin-left:25px;margin-right:10px">码</span></label>
        <input v-model="password" class="input-large" type="password" autocomplete="off" placeholder="8位字母数字" name="data[password]">
        <a href="/reset"><div class="reset">忘记密码</div></a>
        <a href="/register"><div class="reset" style="right:183px">立即注册</div></a>
      </div>
      
      <div class="login-btn" @click="next">登  录
      </div>
      <!-- <div class="tip">学习账号开通请联系IFM中国授权机构</div> -->
      </div>
    </form>
  </div>
</template>
<script>
export default {
    components:{
    },
    data() {
        return {
            phone:'',
            password:''
        }
    },
    methods: {
        async next(){
            if(this.validateItem()){
                try {
                    const res = await this.$http.post('/api/user/login',{account:this.phone,password:this.password});
                    if(Object.hasOwnProperty.call(res,'userinfo')){
                        localStorage.setItem('ifm_token',res.userinfo.token);
                        this.$store.commit('CHANGE_STATE',{userInfo:res.userinfo});
                        this.$toast('登录成功');
                        const tem = setTimeout(() => {
                            this.$router.push('/');
                            clearTimeout(tem);
                        }, 1500);
                    }
                    console.log(res);
                } catch (error) {
                    this.$toast(error.message||'请求失败');
                }
                
            }
        },
        validateItem(){
            const phone = this.phone;
            const pasword = this.password;
            // const myreg=/^[1][3,4,5,6,7,8,9][0-9]{9}$/;
            if(phone===''){
                this.$toast('请输入账号')
                return false;
            }else if(pasword === ''){
                this.$toast('请输入密码')
                return false;
            }
            return true;
        }
    },
    
}
</script>
<style lang="scss" scoped>
@import '../../assets/user.scss';
.reset{
    cursor: pointer;
    bottom: -25px;
    right: 346px;
    position: absolute;
    font-size: 13px;
    color: #235483;
}
.ext{
    position: relative;
    .ext-input{
        // width:80px;
    }
    .get-code{
        position: absolute;
        right: 135px;
        top: 20px;
        border-radius: 4px;
        padding: 6px 6px;
        background: #002c56;
        color: #fff;
        font-size: 13px;
    }
}

.login-btn{
    padding: 9px 24px;
    display: inline-block;
    margin-left: 102px;
    margin-top: 52px;
    cursor: pointer;
    font-size: 16px;
    color: #FFFFFF;
    letter-spacing: 0.45px;
    font-weight: 600;
    font-family: PingFangSC-Semibold;
    background: #A4204F;
}
.tip{
    font-family: PingFangSC-Regular;
    font-size: 16px;
    color: #333333;
    letter-spacing: 0.45px;
    font-weight: 400;
    margin-top: 50px;
    padding-left: 20px;
}
</style>
